/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();
new Swiper("#sp-swiper-btn", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 4500,
  },
  loop: true,
  spaceBetween: 20,
});
new Swiper("#sp-swiper", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 6000,
  },
  pagination: {
    el: ".sp-pagination1",
    type: "bullets",
    clickable: true,
  },
  loop: true,
  spaceBetween: 20,
});
new Swiper("#sp-swiper1", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,
});

let prods = window.product
function getCur(){
  let color = $('#sp-color div.active').attr('data-val')
  // let size = $('#sp-size div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color)[0]
}
function changePrice(){
  let num = $('.btns .num').html()
  let price = (getCur().price * Number(num) / 100).toFixed(2)
  let compare = (getCur().compare_at_price * Number(num) / 100).toFixed(2)
  // if(num == 1){
  //   price = (getCur().price * num / 100).toFixed(2)
  // }else if(num == 2){
  //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
  // }else if(num == 3){
  //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
  // }else {
  //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
  // }
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $('.product-part .price .p').html(price)
  $('.product-part .price .cp span').html(compare)
  let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  // $(".product-part .brand .num").html(off_font);
}
$('.toBuy').click(function(){
  let num = $('.btns .num').html()
  window.location.href = '/cart/' + getCur().id + ':' + num
})
$('.toCart').on('click',function(){
  var data = {
    id: getCur().id,
    quantity: $('.btns .num').html()
  };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    success: function () {
      $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
        $("#cardNum").html(result.item_count);
        $('.c_toast').show();
        setTimeout(function(){
          $('.c_toast').hide();
        },1500)
      });
    },
    dataType: "json",
  });
})
var num = 1;
var v = $(".num").html(1);
$(".jia").click(function () {
    num++;
    v.html(num);
  changePrice();
});
$(".jian").click(function () {
    if (num <= 1) {
        num == 1;
        v.html(num);
    } else {
        num--;
        v.html(num);
    }
  changePrice();
});

// 购物轮播
var thumbsp = new Swiper("#thumbs-p", {
  direction: "vertical",
  spaceBetween: 8,
  slidesPerView: 3,
  watchSlidesVisibility: true, // 防止不可点击
});

let swiper = new Swiper("#swiper-p1", {
  thumbs: {
    swiper: thumbsp,
  },
  on: {
    slideChange: function (e) {
      var activeIndex = e.activeIndex;

      // 计算颜色索引，这里假设每个颜色有一个幻灯片
      var colorIndex = activeIndex;

      // 切换颜色选项
      $("#sp-color .option")
        .eq(colorIndex)
        .addClass("active")
        .siblings()
        .removeClass("active");
      
      changePrice();
    },
  },
  spaceBetween: 20,
});

$("#sp-color .option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");

  // 获取当前选中的颜色选项的索引
  let colorIndex = $("#sp-color .option.active").index();

  // 计算目标幻灯片的索引
  let targetIndex = colorIndex;
  swiper.slideTo(targetIndex);
  changePrice();
});




let spImgList = [
  "https://cdn.shopifycdn.net/s/files/1/0829/2951/6835/files/20240723-p1.png",
  "https://cdn.shopifycdn.net/s/files/1/0829/2951/6835/files/20240723-p2.png",
  "https://cdn.shopifycdn.net/s/files/1/0829/2951/6835/files/20240723-p3.png",
];
let spImgList2 = [
  "https://cdn.shopifycdn.net/s/files/1/0829/2951/6835/files/20240723-b1.png",
  "https://cdn.shopifycdn.net/s/files/1/0829/2951/6835/files/20240723-b2.png",
  "https://cdn.shopifycdn.net/s/files/1/0829/2951/6835/files/20240723-b3.png",
];

$('.buyNow').click(function(){
  let id = $(this).attr('data-id')
  window.location.href = '/cart/' + id + ':1'
})

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            227 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();
